module.exports = __webpack_public_path__ + "static/media/ImportTiff.af70f28a.png";